<template>
    <a
        :href="`/wiki/${topic}`"
        target="_blank"
        rel="noopener"
        class="inline-flex items-center gap-1 text-sm font-medium text-theme-primary no-underline hover:underline"
    >
        📚 Saber más
    </a>
</template>

<script>
export default {
    name: "WikiLearnMoreLink",
    props: {
        topic: { type: String, required: true }
    }
};
</script>
